export default __webpack_public_path__ + "static/media/filter.de9e3a85.svg";